import { createFileRoute } from '@tanstack/react-router'
import { RolesPage } from '@/features/rbac/components/roles-page'
import { RequirePermission } from '@/features/rbac/components/require-permission'

export const Route = createFileRoute('/_authenticated/roles/')({
  component: () => (
    <RequirePermission permission='role.view'>
      <RolesPage />
    </RequirePermission>
  ),
})
